//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const Permissions = {
  AdminManageModerators: 'admin:manage_moderators',
  FanreelModerate: 'fanreel:moderate',
  ModerationView: 'moderation:view',
  UniversalImageActionsProductize: 'universal_image_actions:productize',
  UniversalImageActionsTagging: 'universal_image_actions:tagging',
} as const;
